import React, { FC } from 'react'
import { FontSizeProps, theme } from '../../../theme'

export const MicrowaveIcon: FC<{ size?: FontSizeProps }> = ({
  size = 'x2',
}) => {
  return (
    <svg
      width={theme.fontSizes[size]}
      height={theme.fontSizes[size]}
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0C0.895431 0 0 0.89543 0 2V12C0 13.1046 0.895431 14 2 14C2 14.5523 2.44772 15 3 15H4C4.55228 15 5 14.5523 5 14H15C15 14.5523 15.4477 15 16 15H17C17.5523 15 18 14.5523 18 14C19.1046 14 20 13.1046 20 12V2C20 0.895431 19.1046 0 18 0H2ZM3 3H13V11H3L3 3ZM2 3C2 2.44772 2.44772 2 3 2H14V12H3C2.44772 12 2 11.5523 2 11V3ZM18 11C18 11.5523 17.5523 12 17 12C16.4477 12 16 11.5523 16 11C16 10.4477 16.4477 10 17 10C17.5523 10 18 10.4477 18 11ZM5.35357 6.27486C5.15831 6.0796 5.15831 5.76302 5.35357 5.56775C5.54883 5.37249 5.86542 5.37249 6.06068 5.56775L8.53555 8.04263C8.14503 8.43315 7.51186 8.43315 7.12134 8.04263L5.35357 6.27486ZM11.0104 7.68908L9.24266 5.92131C8.85213 5.53078 8.21897 5.53078 7.82844 5.92131L10.3033 8.39618C10.4986 8.59144 10.8152 8.59144 11.0104 8.39618C11.2057 8.20092 11.2057 7.88434 11.0104 7.68908ZM16 2H18V7H16V2Z"
        fill="black"
      />
    </svg>
  )
}
